import { Link, usePage } from "@inertiajs/react"
import { Globe, LogOut } from "lucide-react"

import { NavMain } from "@/components/nav-main"
import {
  Sidebar,
  SidebarContent,
  SidebarFooter,
  SidebarHeader,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
} from "@/components/ui/sidebar"
import type { CurrentUser, NavItem } from "@/types"

const mainNavItems: NavItem[] = [
  {
    title: "Sites",
    href: "/sites",
    icon: Globe,
  },
]

export function AppSidebar() {
  const { current_user } = usePage<{ current_user?: CurrentUser }>().props

  return (
    <Sidebar collapsible="icon" variant="inset" sidebarMode="vendor">
      <SidebarHeader>
        <SidebarMenu>
          <SidebarMenuItem>
            <SidebarMenuButton size="lg" asChild>
              <Link href="/sites" prefetch>
                <span className="bg-primary text-primary-foreground flex size-8 items-center justify-center rounded-md">
                  <Globe className="size-4" />
                </span>
                <span className="font-display text-base font-semibold">
                  uSites
                </span>
              </Link>
            </SidebarMenuButton>
          </SidebarMenuItem>
        </SidebarMenu>
      </SidebarHeader>

      <SidebarContent>
        <NavMain items={mainNavItems} />
      </SidebarContent>

      <SidebarFooter>
        {current_user ? (
          <SidebarMenu>
            <SidebarMenuItem>
              <SidebarMenuButton size="lg" asChild tooltip={{ children: "Sign out" }}>
                <Link href="/saml/logout" method="delete" as="button">
                  <LogOut className="size-4" />
                  <span className="grid flex-1 text-left leading-tight">
                    <span className="truncate text-sm">
                      {current_user.name ?? current_user.email}
                    </span>
                    <span className="text-muted-foreground truncate text-xs">
                      {current_user.role} · sign out
                    </span>
                  </span>
                </Link>
              </SidebarMenuButton>
            </SidebarMenuItem>
          </SidebarMenu>
        ) : null}
      </SidebarFooter>
    </Sidebar>
  )
}
